import * as Sentry from '@sentry/nextjs';
import { Logger } from 'next-axiom';

const source = typeof window === 'undefined' ? 'backend-log' : 'frontend-log';
const logger = new Logger({ source, autoFlush: true });

// Add sentry breadcrumbs for all log levels
const levels = ['info', 'warn', 'error', 'debug'] as const;
levels.forEach((level) => {
  const originalMethod = logger[level];
  logger[level] = (message: string, data?: Record<string, unknown>) => {
    // Add breadcrumb
    Sentry.addBreadcrumb({
      category: level, // Use log level as category
      message,
      data,
      level: level === 'warn' ? 'warning' : level, // Map to Sentry levels
    });

    // Call the original logger method
    return originalMethod.call(logger, message, data);
  };
});

export { logger };
